import {
  CONFIRMED_CREATE_PRESCRIPTION_ACTION,
  CONFIRMED_GET_SUGGESTED_PRESCRIPTION_ACTION,
  CONFIRMED_GET_PATIENT_PRESCRIPTIONS_ACTION,
  UPDATE_DURATION_REQUEST,
  UPDATE_DURATION_SUCCESS,
  UPDATE_DURATION_FAILURE,
  HOLD_PATIENT_MEDICINE,
  HOLD_PATIENT_MEDICINE_SUCCESS,
  HOLD_PATIENT_MEDICINE_FAIL,
  STOP_PATIENT_PRESCRIPTION_REQUEST,
  STOP_PATIENT_PRESCRIPTION_SUCCESS,
  STOP_PATIENT_PRESCRIPTION_FAIL,
} from "../actions/PrescriptionType";

const initialState = {
  prescriptions: [],
  loading: false,
  error: null,
  patientPrescriptions: [],
  suggestedPrescriptions: [],
  holdMedicineResponse: null,
};

export default function PrescriptionReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_DURATION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }

    case UPDATE_DURATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        prescriptions: state.prescriptions.map((prescription) => {
          console.log("===========> PrescriptionReducer.js <===========");
          console.log("prescription", prescription);

          console.log("action.payload", action.payload);
          return prescription?.prescription_id ===
            action.payload?.prescription_id
            ? action.payload
            : prescription;
        }),
      };
    }

    case UPDATE_DURATION_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case CONFIRMED_CREATE_PRESCRIPTION_ACTION: {
      const prescriptions = [...state.prescriptions];
      prescriptions.push(action.payload);
      return {
        ...state,
        prescriptions,
      };
    }

    case CONFIRMED_GET_SUGGESTED_PRESCRIPTION_ACTION: {
      // Fix: Properly handle the suggested prescriptions data
      return {
        ...state,
        suggestedPrescriptions: Array.isArray(action.payload?.data)
          ? action.payload.data
          : Array.isArray(action.payload)
            ? action.payload
            : [],
      };
    }

    case CONFIRMED_GET_PATIENT_PRESCRIPTIONS_ACTION: {
      return {
        ...state,
        patientPrescriptions: action.payload,
      };
    }
    case HOLD_PATIENT_MEDICINE:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case HOLD_PATIENT_MEDICINE_SUCCESS:
      return {
        ...state,
        loading: false,
        holdMedicineResponse: action.payload,
      };

    case HOLD_PATIENT_MEDICINE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case STOP_PATIENT_PRESCRIPTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case STOP_PATIENT_PRESCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        patientPrescriptions: state.patientPrescriptions.map((prescription) =>
          prescription.prescription_id === action.payload
            ? { ...prescription, is_stop: "Yes" }
            : prescription
        ),
      };

    case STOP_PATIENT_PRESCRIPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
